import Button from '@uikit/components/Button/Button';
import ButtonLink from '@uikit/components/ButtonLink/ButtonLink';
import RichText from '@uikit/components/RichText/RichText';
import clsx from 'clsx';
import { ButtonColor, ShowIcon } from '../Button/consts';
import styles from './InfoBox.module.scss';
import {
  InfoBoxButtonStyle,
  InfoBoxColor,
  InfoBoxProps,
  InfoBoxStyle,
} from './interfaces';

const InfoBox = ({
  color = InfoBoxColor.Simple,
  headline,
  text,
  buttonLabel,
  buttonStyle = InfoBoxButtonStyle.Button,
  boxStyle = InfoBoxStyle.Centered,
  headlineTag: HeadlineTag = 'div',
  ...props
}: InfoBoxProps) => {
  const hasButtonLinkStyle =
    buttonLabel && buttonStyle === InfoBoxButtonStyle.Link;
  const hasButtonButtonStyle =
    buttonLabel && buttonStyle !== InfoBoxButtonStyle.Link;

  return (
    <div className={styles.wrapper}>
      <div
        className={clsx(styles.base, {
          [styles.simple]: color === InfoBoxColor.Simple,
          [styles.highlighted]: color === InfoBoxColor.Highlighted,
          [styles.sideBySide]: boxStyle === InfoBoxStyle.SideBySide,
        })}
      >
        {headline && (
          <HeadlineTag className={styles.headline}>{headline}</HeadlineTag>
        )}
        <div className={styles.group}>
          <RichText className={styles.text}>{text}</RichText>
          {hasButtonLinkStyle && (
            <ButtonLink className={styles.buttonLink} {...props}>
              {buttonLabel}
            </ButtonLink>
          )}
          {hasButtonButtonStyle && (
            <Button
              {...props}
              className={styles.button}
              color={
                color === InfoBoxColor.Simple
                  ? ButtonColor.Primary
                  : ButtonColor.Secondary
              }
              icon={'action/arrow-right'}
              showIcon={ShowIcon.ShowIcon}
            >
              {buttonLabel}
            </Button>
          )}
        </div>
      </div>
    </div>
  );
};

export default InfoBox;
